import router from '@/router';
import { i18nRoute } from '@/i18n';

export const navigateBack = (minHistoryLength: number, stepsBack: number, route: string): void => {
    if (window.history.length > minHistoryLength) {
        router.go(stepsBack);
    } else {
        router.push(i18nRoute({ name: route }));
    }
};
